import { GlFormCheckbox, GlTooltipDirective, GlSprintf, GlIcon, GlDisclosureDropdown, GlBadge, GlLink, GlPopover } from '@gitlab/ui';
import ImmutableBadge from 'ee_component/packages_and_registries/container_registry/explorer/components/details_page/immutable_badge.vue';
import { localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
import { numberToHumanSize } from '~/lib/utils/number_utils';
import { n__ } from '~/locale';
import ClipboardButton from '~/vue_shared/components/clipboard_button.vue';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
import ListItem from '~/vue_shared/components/registry/list_item.vue';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import { REMOVE_TAG_BUTTON_TITLE, DIGEST_LABEL, CREATED_AT_LABEL, PUBLISHED_DETAILS_ROW_TEXT, MANIFEST_DETAILS_ROW_TEST, MANIFEST_MEDIA_TYPE_ROW_TEXT, CONFIGURATION_DETAILS_ROW_TEST, MISSING_MANIFEST_WARNING_TOOLTIP, NOT_AVAILABLE_TEXT, NOT_AVAILABLE_SIZE, MORE_ACTIONS_TEXT, COPY_IMAGE_PATH_TITLE, SIGNATURE_BADGE_TOOLTIP, DOCKER_LIST_MEDIA_TYPE, OCI_INDEX_MEDIA_TYPE, MinimumAccessLevelText } from '../../constants/index';
import PlatformBadgesRow from './platform_badges_row.vue';
import SignatureDetailsModal from './signature_details_modal.vue';
export default {
    name: 'TagsListRow',
    components: {
        GlSprintf,
        GlFormCheckbox,
        GlIcon,
        GlDisclosureDropdown,
        GlBadge,
        GlLink,
        ListItem,
        ClipboardButton,
        TimeAgoTooltip,
        DetailsRow,
        SignatureDetailsModal,
        GlPopover,
        ImmutableBadge,
        PlatformBadgesRow
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tag: {
            type: Object,
            required: true
        },
        selectable: {
            type: Boolean,
            default: true,
            required: false
        },
        selected: {
            type: Boolean,
            default: false,
            required: false
        },
        canDelete: {
            type: Boolean,
            default: false,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'delete',
        'select'
    ],
    i18n: {
        REMOVE_TAG_BUTTON_TITLE,
        DIGEST_LABEL,
        CREATED_AT_LABEL,
        PUBLISHED_DETAILS_ROW_TEXT,
        MANIFEST_DETAILS_ROW_TEST,
        MANIFEST_MEDIA_TYPE_ROW_TEXT,
        CONFIGURATION_DETAILS_ROW_TEST,
        MISSING_MANIFEST_WARNING_TOOLTIP,
        MORE_ACTIONS_TEXT,
        COPY_IMAGE_PATH_TITLE,
        SIGNATURE_BADGE_TOOLTIP
    },
    data () {
        return {
            selectedDigest: null
        };
    },
    computed: {
        items () {
            return [
                {
                    text: this.$options.i18n.REMOVE_TAG_BUTTON_TITLE,
                    variant: 'danger',
                    extraAttrs: {
                        'data-testid': 'single-delete-button'
                    },
                    action: ()=>{
                        this.$emit('delete');
                    }
                }
            ];
        },
        formattedSize () {
            return this.tag.totalSize ? numberToHumanSize(Number(this.tag.totalSize)) : NOT_AVAILABLE_SIZE;
        },
        layers () {
            return this.tag.layers ? n__('%d layer', '%d layers', this.tag.layers) : '';
        },
        shortDigest () {
            // remove sha256: from the string, and show only the first 7 char
            return this.tag.digest?.substring(7, 14) ?? NOT_AVAILABLE_TEXT;
        },
        publishDateTime () {
            return this.tag.publishedAt || this.tag.createdAt;
        },
        publishedDateTime () {
            return localeDateFormat.asDateTimeFull.format(newDate(this.publishDateTime));
        },
        formattedRevision () {
            // to be removed when API response is adjusted
            // see https://gitlab.com/gitlab-org/gitlab/-/issues/225324
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `sha256:${this.tag.revision}`;
        },
        tagLocation () {
            return this.tag.path?.replace(`:${this.tag.name}`, '');
        },
        isEmptyRevision () {
            return this.tag.revision === '';
        },
        isInvalidTag () {
            return !this.tag.digest;
        },
        showConfigDigest () {
            return !this.isInvalidTag && !this.isEmptyRevision;
        },
        showManifestMediaType () {
            return !this.isInvalidTag && this.tag.mediaType;
        },
        showManifestPlatforms () {
            return !this.isInvalidTag && this.isMultiPlatformImage;
        },
        signatures () {
            const referrers = this.tag.referrers || [];
            // All referrers should be signatures, but we'll filter by signature artifact types as a sanity check.
            return referrers.filter(({ artifactType })=>artifactType === 'application/vnd.dev.cosign.artifact.sig.v1+json');
        },
        isMultiPlatformImage () {
            return this.tag.mediaType === DOCKER_LIST_MEDIA_TYPE || this.tag.mediaType === OCI_INDEX_MEDIA_TYPE;
        },
        isProtected () {
            return this.tag.protection?.minimumAccessLevelForDelete != null || this.tag.protection?.minimumAccessLevelForPush != null;
        },
        tagRowId () {
            return `${this.tag.name}_badge`;
        },
        accessLevelForDelete () {
            return MinimumAccessLevelText[this.tag.protection?.minimumAccessLevelForDelete];
        },
        accessLevelForPush () {
            return MinimumAccessLevelText[this.tag.protection?.minimumAccessLevelForPush];
        }
    }
};
